import { useTranslation } from 'react-i18next';
import { useFontSize, type FontSizeLevel } from '@/hooks/useFontSize';

const LEVELS: { key: FontSizeLevel; scale: number }[] = [
  { key: 'klein', scale: 0.875 },
  { key: 'normaal', scale: 1 },
  { key: 'groot', scale: 1.125 },
  { key: 'extra-groot', scale: 1.25 },
];

export function FontSizeSelector() {
  const { t } = useTranslation();
  const { fontSize, setFontSize } = useFontSize();

  return (
    <div data-testid="font-size-selector" className="flex flex-col gap-1.5">
      <span className="text-[0.6875rem] font-medium" style={{ color: 'var(--foreground-muted)' }}>
        {t('user.fontSize')}
      </span>
      <div
        className="flex rounded-lg overflow-hidden"
        style={{ border: '1px solid var(--border)' }}
        role="radiogroup"
        aria-label={t('user.fontSize')}
      >
        {LEVELS.map((level) => (
          <button
            key={level.key}
            data-testid={`font-size-${level.key}`}
            role="radio"
            aria-checked={fontSize === level.key}
            onClick={() => setFontSize(level.key)}
            className="flex-1 px-2 py-1 text-center transition-all duration-100"
            style={{
              fontSize: `${level.scale * 0.75}rem`,
              fontWeight: fontSize === level.key ? 600 : 400,
              backgroundColor: fontSize === level.key ? 'var(--primary)' : 'var(--background)',
              color: fontSize === level.key ? 'white' : 'var(--foreground)',
            }}
          >
            Aa
          </button>
        ))}
      </div>
    </div>
  );
}
